// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import { difference } from 'lodash'

import {
  Modal,
  Button,
  SvgIcon,
  Spinner,
  Warning,
  RadioGroup
} from '../'

import { QUERY_PRODUCTS } from '../../queries'


export class InvestmentAddModal extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    clientInvestmentProducts: PropTypes.arrayOf(PropTypes.string),
    activeInvestmentEmployerProducts: PropTypes.arrayOf(PropTypes.string),
    onAddConfirmClick: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired
  }

  state = {
    productName: null
  }

  render() {
    const { title, clientInvestmentProducts, activeInvestmentEmployerProducts, onCloseClick, onAddConfirmClick } = this.props

    return (
      <Query query={QUERY_PRODUCTS} variables={{ family: 'investments' }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Spinner className='slds-is-relative' />
          }

          if (error) {
            return <Warning>Failed to fetch product data</Warning>
          }

          let availableProductOptions = data.products.edges.map(({ node: product }) => (
            {
              label: product.name,
              value: product.name
            }
          ))

          let productsAvailableToClient = difference(activeInvestmentEmployerProducts, clientInvestmentProducts)

          availableProductOptions = availableProductOptions.filter(productOption => (
            productsAvailableToClient.indexOf(productOption.value) > -1
          ))
          const availableProductsLeft = availableProductOptions.length > 0

          return (
            <Modal
              heading={title}
              body={
                <div className='slds-text-align_center u-font-size-larger'>
                  {availableProductsLeft
                    ? <RadioGroup
                        id='productName'
                        label='Choose from available products:'
                        options={availableProductOptions}
                        value={this.state.productName}
                        onClick={e => this.setState({ productName: e.target.value })}
                        className='slds-p-left_medium slds-p-bottom_medium'
                      />
                    : <div>
                        <SvgIcon
                          variant='utility'
                          symbol='info'
                          size='small'
                          colour='light'
                          className='slds-p-right_x-small'
                        />
                        {activeInvestmentEmployerProducts.length === 0
                          ? 'The employer has no active investment products'
                          : 'The client currently has all available investment products'
                        }
                      </div>
                  }
                  <div className='slds-m-top_large'>
                    {availableProductsLeft
                      ? <Fragment>
                          <Button minWidth='120px' onClick={onCloseClick}>
                            Cancel
                          </Button>
                          <Button
                            type='brand'
                            disabled={this.state.productName === null}
                            minWidth='120px'
                            onClick={() => onAddConfirmClick(this.state.productName)}>
                            Add investment
                          </Button>
                        </Fragment>
                      : <Button type='brand' minWidth='120px' onClick={onCloseClick}>
                          OK
                        </Button>
                    }
                  </div>
                </div>
              }
              containerStyle={availableProductsLeft
                ? { width: '200px' }
                : null
              }
            />
          )
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/investment-add-modal/index.js